<mat-expansion-panel
  [expanded]="fileSectionRequired"
  (afterExpand)="scrollToFileAttachments()"
  (opened)="onFileAttachmentOpened()"
  (closed)="onFileAttachmentClosed()">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <form [formGroup]="fileConfig">
        <mat-slide-toggle id="attachmentRequiredCheckbox" formControlName="required"
          [matTooltip]="'Require an attachment from the ' + recordTerm + '.'"
          [matTooltipPosition]="'above'"
          [matTooltipShowDelay]="500"
          (click)="$event.stopPropagation()"
          (keydown.space)="$event.stopPropagation()"
          (keydown.enter)="$event.stopPropagation()">
        </mat-slide-toggle>
      </form>
      <span class="file-attachment-label">
        <mat-icon fontIcon="attach_file" class="file-attachment"></mat-icon>
        File attachment
      </span>
      <mat-panel-description> Require an attachment from the {{ recordTerm }} </mat-panel-description>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <ng-template matExpansionPanelContent>
    <div class="panel-body" [ngClass]="{ disabled: false }">
      @if (fileSectionRequired) {
        <div class="panel-container">
          <form [formGroup]="fileConfig">
            <ul class="file-restrictions-section">
            <li class="restrictions-container horizontal border-right">
              @if (showUploadSourceSelector) {
                <div class="upload-source">
                  <app-upload-source-selector
                    [fileSection]="fileSection"
                    [namespace]="namespace">
                  </app-upload-source-selector>
                </div>
              }
              <div class="checkbox-wrapper">
                <mat-checkbox
                  class="required-checkbox"
                  [matTooltip]="'Uncheck to make the attachment optional'"
                  [matTooltipPosition]="'right'"
                  [matTooltipShowDelay]="500"
                  [checked]="!fileConfig.get('optional').value"
                  [disabled]="this.fileConfig.get('optional')?.disabled"
                  (change)="onDocumentAttachmentOptionalChange()"
                >
                  Required
                </mat-checkbox>
              </div>
              <div class="checkbox-wrapper">
                <mat-checkbox
                  class="required-checkbox"
                  formControlName="attachmentAnonymise"
                  [matTooltip]="'Anonymise the attachment file to remove personal data'"
                  [matTooltipPosition]="'right'"
                  [matTooltipShowDelay]="500"
                >
                  Anonymise
                </mat-checkbox>
              </div>
            </li>
            <li>
              <app-attachment-restrictions
                [fileSection]="fileSection"
                [entityType]="_entityType"
                [namespace]="namespace">
              </app-attachment-restrictions>
            </li>
          </ul>
          </form>
          @if (!_forceEnabled) {
            <form [formGroup]="mergeConfigForm">
              <ul class="attachment-options basic-flex-container">
                <ng-container formGroupName="merge-styling">
                  <li class="select-container attachment-font-family">
                    <div class="label-with-icon">
                      <label><mat-icon fontIcon="text_fields"></mat-icon>Attachment font</label>
                    </div>
                    <mat-select
                      formControlName="attachmentFontFamily"
                      placeholder="Attachment original"
                      matTooltip="Specify a standard font for text in the attachment file"
                      matTooltipShowDelay="500"
                    >
                      <mat-option value="original">Attachment original</mat-option>
                      @for (family of fontFamilies; track family) {
                        <mat-option [value]="family" [style.font-family]="family">{{ family }}</mat-option>
                      }
                    </mat-select>
                  </li>
                  <li class="select-container attachment-font-size">
                    <div class="label-with-icon">
                      <label><mat-icon fontIcon="text_increase"></mat-icon>Attachment font size</label>
                    </div>
                    <mat-select
                      formControlName="attachmentFontSizeType"
                      placeholder="Attachment original"
                      matTooltip="Specify a minimum or standard font size for text in the attachment file"
                      matTooltipShowDelay="500"
                    >
                      <mat-option value="original">Attachment original</mat-option>
                      <mat-option value="minimum">Minimum font size</mat-option>
                      <mat-option value="standard">Standard font size</mat-option>
                    </mat-select>
                  </li>
                  @if (attachmentFontSizeType !== 'original') {
                    <li
                      class="input-container specify-font-size"
                    >
                      <label><mat-icon fontIcon="text_increase"></mat-icon>Specify {{ attachmentFontSizeType }} font size</label>
                      <input
                        type="number"
                        formControlName="attachmentFontSize"
                        placeholder="Enter font size"
                        min="1"
                        max="1638"
                        step="0.5"
                        matTooltip="Automatically rounded to the nearest 0.5"
                        matTooltipShowDelay="500"
                      />
                    </li>
                  }
                </ng-container>
                <ng-container formGroupName="attachment-placement">
                  <li class="select-container attachment-position">
                    <div class="label-with-icon">
                      <label><mat-icon fontIcon="swap_vert"></mat-icon>Attachment position</label>
                    </div>
                    <mat-select
                      #attachmentPositionTooltip="matTooltip"
                      formControlName="position"
                      matTooltip="Where the attachment is placed in the template file. Choose 'At section break' and add a section break to the template where the attachment should appear"
                      matTooltipShowDelay="500"
                      (openedChange)="attachmentPositionTooltip.hide()"
                    >
                      <mat-option [value]="AttachmentPosition.End">End of document</mat-option>
                      <mat-option [value]="AttachmentPosition.SectionBreak">At section break</mat-option>
                    </mat-select>
                  </li>
                  @if (attachmentPosition === AttachmentPosition.SectionBreak) {
                    <li class="input-container attachment-section-break">
                      <label><mat-icon fontIcon="format_line_spacing"></mat-icon>Section break</label>
                      <input
                        type="number"
                        formControlName="sectionBreak"
                        placeholder="E.g. 1"
                        [min]="FIRST_SECTION_BREAK"
                        [max]="MAX_SECTION_BREAK"
                        step="1"
                        matTooltip="Counting section breaks in the template file from the top, starting at 1. The attachment is placed at the end of the section this break closes"
                        matTooltipShowDelay="500"
                      />
                      @if (showSectionBreakError) {
                        <small class="section-break-error">
                          <mat-icon fontIcon="error_outline"></mat-icon>
                          Enter a whole number between {{ FIRST_SECTION_BREAK }} and {{ MAX_SECTION_BREAK }}
                        </small>
                      }
                    </li>
                  }
                </ng-container>
              </ul>
              <ul class="attachment-options basic-flex-container grey-background" formGroupName="merge-styling">
                <li class="select-container attachment-page-size">
                  <div class="label-with-icon">
                    <label><mat-icon fontIcon="plagiarism"></mat-icon>Attachment page size</label>
                  </div>
                  <mat-select
                    formControlName="attachmentPageSizeType"
                    matTooltip="Specify the page size of the attachment"
                  >
                    <mat-option value="original">Attachment original</mat-option>
                    <mat-option value="match">Match template file</mat-option>
                  </mat-select>
                </li>
                <li class="select-container attachment-margins">
                  <div class="label-with-icon">
                    <label><mat-icon fontIcon="aspect_ratio"></mat-icon>Attachment margins</label>
                  </div>
                  <mat-select
                    formControlName="attachmentMarginType"
                    matTooltip="Specify the margins of the attachment file"
                  >
                    <mat-option value="original">Attachment original</mat-option>
                    <mat-option value="match">Match template file</mat-option>
                  </mat-select>
                </li>
              </ul>
            </form>
          }
          </div>
      }
    </div>
  </ng-template>
</mat-expansion-panel>

<!--{{ fileSection.value | json }}-->
<!--{{ mergeSection.value | json }}-->
